var _path, _rect, _path2, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect4, _rect5, _rect6, _rect7, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _ellipse, _ellipse2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _polygon, _path38, _path39, _path40, _polygon2, _path41, _polygon3, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _rect8, _path49, _rect9, _path50, _rect10, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _circle, _circle2, _circle3, _polygon4, _path102, _rect11, _path103, _path104, _path105;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppDev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_90_code_development",
    "data-name": "#90_code_development",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.72,251.14a26,26,0,0,1-7.44-1c-6.38-1.92-12.09-7.27-15.65-14.66-3.19-6.62-4.47-13.91-5.7-21a.47.47,0,0,1,.4-.56.48.48,0,0,1,.56.39c1.22,7,2.48,14.22,5.61,20.72,3.45,7.15,8.94,12.3,15.06,14.15,4.45,1.33,9.3,1,13.88.46,9.81-1.16,15.79-4.2,18.3-9.28.09-.2.18-.38.24-.55-1.57.44-3.12,1-4.64,1.57-1.26.46-2.56.93-3.86,1.34A41.46,41.46,0,0,1,224.91,244c-3.15-.56-5.07-2.08-5.14-4.06s1.64-3.56,4.69-4.44a49.06,49.06,0,0,1,25.65-.47c2.4.6,3.72,1.6,4,3.05a3.93,3.93,0,0,1,.06.48c.38-.09.76-.17,1.15-.24,4.06-.72,8.3-.31,12.4.08,5.82.56,11.32,1.09,16.28-1.35a.49.49,0,0,1,.65.23.48.48,0,0,1-.22.65c-5.21,2.55-11.1,2-16.8,1.44-4-.39-8.21-.79-12.14-.09-.48.08-1,.19-1.43.3a6.47,6.47,0,0,1-.49,1.28c-2.66,5.4-8.9,8.61-19.05,9.82A57.34,57.34,0,0,1,227.72,251.14Zm10.43-16.64a48.2,48.2,0,0,0-13.42,1.91c-1.22.35-4.06,1.41-4,3.48s3.33,3,4.33,3.13a40.56,40.56,0,0,0,19.11-1.18c1.28-.4,2.57-.87,3.81-1.32,1.71-.63,3.45-1.27,5.24-1.74a2.11,2.11,0,0,0,0-.51c-.23-1.06-1.32-1.81-3.33-2.32A48,48,0,0,0,238.15,234.5Z",
    fill: "#e6e7e8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 275.64,
    y: 98.1,
    width: 74.61,
    height: 148.72,
    rx: 4.76,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M345.49,247.3H280.4a5.25,5.25,0,0,1-5.24-5.24V102.85a5.25,5.25,0,0,1,5.24-5.24h65.09a5.25,5.25,0,0,1,5.25,5.24V242.06A5.25,5.25,0,0,1,345.49,247.3ZM280.4,98.58a4.27,4.27,0,0,0-4.27,4.27V242.06a4.27,4.27,0,0,0,4.27,4.27h65.09a4.27,4.27,0,0,0,4.27-4.27V102.85a4.27,4.27,0,0,0-4.27-4.27Z",
    fill: "#231f20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 279.56,
    y: 111.55,
    width: 66.77,
    height: 114.45,
    fill: "#9db0ef"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 303.67,
    y: 231.57,
    width: 18.55,
    height: 10.71,
    rx: 2.92,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319.29,242.76H306.6a3.41,3.41,0,0,1-3.41-3.41V234.5a3.41,3.41,0,0,1,3.41-3.41h12.69a3.41,3.41,0,0,1,3.42,3.41v4.85A3.42,3.42,0,0,1,319.29,242.76Zm-12.69-10.7a2.44,2.44,0,0,0-2.44,2.44v4.85a2.44,2.44,0,0,0,2.44,2.44h12.69a2.44,2.44,0,0,0,2.44-2.44V234.5a2.44,2.44,0,0,0-2.44-2.44Z",
    fill: "#e6e7e8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M319.69,105h-19a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49h19a.48.48,0,0,1,.48.49A.47.47,0,0,1,319.69,105Z",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M324.9,105h-2.55a.48.48,0,0,1-.48-.48.49.49,0,0,1,.48-.49h2.55a.49.49,0,0,1,.49.49A.48.48,0,0,1,324.9,105Z",
    fill: "#e6e7e8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M337.85,183.46H288a3.74,3.74,0,0,1-3.74-3.74V155.1a3.74,3.74,0,0,1,3.74-3.75h49.81a3.75,3.75,0,0,1,3.75,3.75v24.62A3.75,3.75,0,0,1,337.85,183.46ZM288,152.33a2.77,2.77,0,0,0-2.77,2.77v24.62a2.77,2.77,0,0,0,2.77,2.77h49.81a2.77,2.77,0,0,0,2.77-2.77V155.1a2.77,2.77,0,0,0-2.77-2.77Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.78,180.63a.49.49,0,0,1-.3-.87l24.68-19.53a.49.49,0,0,1,.65.05l14.73,15.28a.49.49,0,0,1,0,.69.48.48,0,0,1-.68,0l-14.42-15-24.34,19.26A.47.47,0,0,1,284.78,180.63Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M341.11,175.73a.48.48,0,0,1-.36-.17l-8.18-9.27-9.35,7.81a.48.48,0,0,1-.62-.74l9.71-8.12a.48.48,0,0,1,.67,0l8.49,9.63a.48.48,0,0,1,0,.68A.44.44,0,0,1,341.11,175.73Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M324.19,164.4a3.79,3.79,0,1,1,3.78-3.78A3.79,3.79,0,0,1,324.19,164.4Zm0-6.6a2.82,2.82,0,1,0,2.81,2.82A2.82,2.82,0,0,0,324.19,157.8Z",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 285.77,
    y: 207.37,
    width: 9.53,
    height: 11.04,
    rx: 3.42,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 300.71,
    y: 207.37,
    width: 9.53,
    height: 11.04,
    rx: 3.42,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 207.37,
    width: 9.53,
    height: 11.04,
    rx: 3.42,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 330.59,
    y: 207.37,
    width: 9.53,
    height: 11.04,
    rx: 3.42,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M340.4,121.09H285.49a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49H340.4a.49.49,0,0,1,.49.49A.48.48,0,0,1,340.4,121.09Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M340.4,128.83H285.49a.49.49,0,1,1,0-1H340.4a.49.49,0,1,1,0,1Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M340.4,136.57H285.49a.49.49,0,0,1-.49-.49.48.48,0,0,1,.49-.48H340.4a.48.48,0,0,1,.49.48A.49.49,0,0,1,340.4,136.57Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M340.4,144.31H285.49a.49.49,0,0,1,0-1H340.4a.49.49,0,1,1,0,1Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M340.4,192.25H285.49a.49.49,0,0,1,0-1H340.4a.49.49,0,0,1,0,1Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M340.4,200H285.49a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49H340.4a.49.49,0,0,1,.49.49A.48.48,0,0,1,340.4,200Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M330.17,45.85s1.23-5.24.09-8.22A4.29,4.29,0,0,0,326,34.94s-8.28-1.84-10.67-4l1.08,3.82a11,11,0,0,1-4.14-1.13,3.77,3.77,0,0,0,1.07,3.68,4.42,4.42,0,0,1-3.82,0s2.27,5.57,7.55,5C320.51,41.8,326.6,47,330.17,45.85Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M329,46.51c-1.89,0-4.1-1-6.26-2s-4.19-2-5.64-1.79c-5.59.65-8-5.19-8.06-5.25a.49.49,0,0,1,.7-.6,3.61,3.61,0,0,0,2.7.26,4.38,4.38,0,0,1-.67-3.6.45.45,0,0,1,.26-.31.53.53,0,0,1,.41,0,12.71,12.71,0,0,0,3.28,1l-.89-3.14a.5.5,0,0,1,.21-.55.48.48,0,0,1,.58.06c2.16,2,9.59,3.69,10.39,3.88a4.71,4.71,0,0,1,4.7,3c1.19,3.08,0,8.28-.07,8.5a.46.46,0,0,1-.31.35A4.2,4.2,0,0,1,329,46.51Zm1.17-.66h0Zm-12.73-4.16c1.64,0,3.62.93,5.71,1.9,2.39,1.12,4.86,2.27,6.61,1.87.23-1.1,1-5.23.05-7.65A3.81,3.81,0,0,0,326,35.42h-.15c-.3-.07-6.53-1.46-9.73-3.31l.71,2.51a.5.5,0,0,1-.08.43.49.49,0,0,1-.39.19,10.78,10.78,0,0,1-3.76-.92,3,3,0,0,0,1,2.61.51.51,0,0,1,.17.43.47.47,0,0,1-.27.38,5.28,5.28,0,0,1-3,.4c.92,1.5,3,4,6.49,3.59A3.29,3.29,0,0,1,317.44,41.69Z",
    fill: "#231f20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M337.16,89.7s7.22-15.79,6.34-26.14-7.66-11-10-11.13-14.81-1.81-19.36,3.76-3.37,32.4-3.37,32.4Z",
    fill: "#9db0ef"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M310.24,83.28A93.85,93.85,0,0,0,295.09,92c-4.22,2.86-6.61,33.05-6.61,33.05s.87,4.85,6.48,4.09l14.77-33.63S315,83.15,310.24,83.28Z",
    fill: "#231f20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M293.81,129.68A5.79,5.79,0,0,1,288,125.1a.49.49,0,0,1,0-.12c.25-3.12,2.54-30.5,6.82-33.41a95.26,95.26,0,0,1,15.25-8.74.33.33,0,0,1,.17,0,2.15,2.15,0,0,1,1.93.92c1.87,2.75-1.58,11-2,12l-14.77,33.64a.48.48,0,0,1-.38.28A8.88,8.88,0,0,1,293.81,129.68ZM289,125c.11.52,1.07,4.15,5.66,3.67l14.66-33.37c1-2.4,3.4-9.08,2.07-11a1.15,1.15,0,0,0-1-.5,98.08,98.08,0,0,0-15,8.62C292.07,94.61,289.64,116.6,289,125Z",
    fill: "#231f20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M337.75,86.38s-21.21.61-26.2-.12c0,0-.28.06-3.94,6.8s1.6,37.55,1.6,37.55,4.82,5.1,8.63,4.37l4.51-35.13s7.69.23,12-2.83C337.31,94.87,337.18,90.28,337.75,86.38Z",
    fill: "#231f20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M317.06,135.54c-3.82,0-8-4.4-8.21-4.6a.45.45,0,0,1-.12-.25c-.22-1.26-5.25-31-1.55-37.86s4-7,4.27-7h.17c4.89.73,25.91.13,26.12.12a.47.47,0,0,1,.49.56c-.1.72-.19,1.47-.27,2.22-.37,3.38-.75,6.87-3.37,8.75-3.8,2.72-10.08,2.92-11.81,2.92L318.32,135a.49.49,0,0,1-.39.42A4.94,4.94,0,0,1,317.06,135.54Zm-7.4-5.16c.67.68,4.58,4.46,7.74,4.17l4.47-34.76a.47.47,0,0,1,.5-.42c.08,0,7.57.18,11.66-2.74,2.26-1.63,2.62-4.9,3-8.07.06-.56.12-1.13.19-1.68-3.42.09-20.47.51-25.43-.11-.29.42-1.18,1.83-3.73,6.52C304.62,99.58,309.27,128.05,309.66,130.38Z",
    fill: "#231f20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M314.13,56.19s-3.36,6.47-5.34,9.79a69.16,69.16,0,0,1-6.29,8.09s-15.25,5.42-15.34,5.71,1.44,5.42,1.44,5.42,16-1.15,18.64-2.4,8-7.4,8-7.4Z",
    fill: "#9db0ef"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M320.34,52.72l.91,5.52a4.1,4.1,0,0,0,5.26,1.3C330,58,330,55.36,330,55.36l-1.86-10.2s-3.22-1.25-4.89-7.53c0,0-8,.61-7.45,3.6,0,0-.1,5.63.75,8.37A4.94,4.94,0,0,0,320.34,52.72Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M324.55,60.48a4.72,4.72,0,0,1-3.71-2,.67.67,0,0,1-.07-.18l-.86-5.21a5.12,5.12,0,0,1-3.84-3.36c-.87-2.79-.78-8.3-.78-8.53a2,2,0,0,1,.44-1.55c1.57-2,6.86-2.48,7.46-2.52a.49.49,0,0,1,.51.36c1.57,5.91,4.57,7.19,4.6,7.2a.48.48,0,0,1,.3.36l1.86,10.2c0,.21,0,3.09-3.75,4.72A5.37,5.37,0,0,1,324.55,60.48Zm-2.84-2.43a3.62,3.62,0,0,0,4.61,1.05c3.1-1.36,3.18-3.65,3.18-3.75l-1.81-9.86c-.82-.43-3.34-2.16-4.82-7.34-1.74.18-5.35.8-6.38,2.12a1.05,1.05,0,0,0-.23.87c0,.15-.08,5.68.74,8.32a4.3,4.3,0,0,0,3.37,2.77l.2.06a.51.51,0,0,1,.25.35Z",
    fill: "#231f20"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M326,45.36a2.43,2.43,0,0,1,.58-1.4,4.26,4.26,0,0,1,1.15-.87,1.84,1.84,0,0,1,.74-.27,1.49,1.49,0,0,1,.55.1,1.87,1.87,0,0,1,1,.75,2.16,2.16,0,0,1,.23,1,4.06,4.06,0,0,1-.08,1.15,2.9,2.9,0,0,1-1.31,1.82,3,3,0,0,1-2.21.35",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M327.33,48.59a3.58,3.58,0,0,1-.8-.1.49.49,0,0,1-.36-.59.48.48,0,0,1,.59-.35,2.54,2.54,0,0,0,1.85-.29,2.48,2.48,0,0,0,1.09-1.52,3.91,3.91,0,0,0,.07-1,1.71,1.71,0,0,0-.17-.8,1.39,1.39,0,0,0-.77-.55,1.59,1.59,0,0,0-.36-.07,1.36,1.36,0,0,0-.53.22,3.65,3.65,0,0,0-1,.75,1.87,1.87,0,0,0-.46,1.12.5.5,0,0,1-.52.46.48.48,0,0,1-.45-.52,2.92,2.92,0,0,1,.69-1.69,4.56,4.56,0,0,1,1.28-1,2.35,2.35,0,0,1,1-.34,2.14,2.14,0,0,1,.74.13,2.27,2.27,0,0,1,1.29,1,2.67,2.67,0,0,1,.3,1.25,5,5,0,0,1-.09,1.28,3.42,3.42,0,0,1-3.32,2.63Z",
    fill: "#231f20"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M320.94,43.88s-1.5,3.12-1,3.55,1.75-.08,1.75-.08",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M320.58,48.08a1.42,1.42,0,0,1-.92-.28c-.21-.17-.82-.67.85-4.13a.49.49,0,0,1,.64-.23.48.48,0,0,1,.23.65,10.28,10.28,0,0,0-1,3,2.17,2.17,0,0,0,1.18-.19.5.5,0,0,1,.64.26.49.49,0,0,1-.27.64A3.85,3.85,0,0,1,320.58,48.08Zm-.23-.93Z",
    fill: "#231f20"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.34,
    cy: 43.1,
    rx: 0.48,
    ry: 0.67,
    transform: "translate(-2.7 32.88) rotate(-5.8)",
    fill: "#231f20"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.3,
    cy: 43.81,
    rx: 0.48,
    ry: 0.67,
    transform: "translate(-2.71 30.23) rotate(-5.4)",
    fill: "#231f20"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M321.38,50.53a7.53,7.53,0,0,1-2.67-.55.48.48,0,0,1-.25-.64.5.5,0,0,1,.64-.25s2.27,1,3.8.13a3.09,3.09,0,0,0,1.4-2.37.49.49,0,0,1,1,.16,4,4,0,0,1-1.9,3.06A4,4,0,0,1,321.38,50.53Z",
    fill: "#231f20"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M320.34,52.72s3.56.22,5.4-1.27c0,0-1.48,5-4.77,5Z",
    fill: "#231f20"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M321,57a.47.47,0,0,1-.47-.41l-.63-3.78a.47.47,0,0,1,.12-.41.48.48,0,0,1,.39-.16s3.4.19,5.06-1.16a.49.49,0,0,1,.77.52c-.06.21-1.61,5.34-5.23,5.4Zm0-3.77.46,2.76c1.7-.29,2.83-2.15,3.42-3.43A11.13,11.13,0,0,1,320.91,53.22Z",
    fill: "#231f20"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M340.12,55c2.85.5,14.38,27.16,10.43,30.2-6.16,4.75-27.6,0-27.6,0l1.75-8.27s13.78.39,14-2.44-8-15.93-6.94-17.89S340.12,55,340.12,55Z",
    fill: "#9db0ef"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M326.18,79.61a30.76,30.76,0,0,1-6.85-.33,20.9,20.9,0,0,0-5.12-.59,19.19,19.19,0,0,0-6.6,1.51.51.51,0,0,0-.23.15c-.2.28.28.56.63.57a9.37,9.37,0,0,0,2.69-.34,25.63,25.63,0,0,0-6.09,3.24c-.22.15-.45.39-.35.63s.54.2.82.07L310,82.27a12.44,12.44,0,0,0-3.5,2.13c-.14.13-.31.3-.26.49s.56.27.87.12a29.37,29.37,0,0,0,4.28-2.62l-3,2.34c0,.24.23.45.48.46a1.4,1.4,0,0,0,.7-.24l3.39-2-2.11,1.48c-.34.23-.72.61-.55,1s.84.3,1.28.11A25.38,25.38,0,0,1,317,83.88a9.06,9.06,0,0,1,2-.41,18.56,18.56,0,0,1,3.09.68c1.54.34,3.07.69,4.6,1",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M310.79,86.18a1.21,1.21,0,0,1-.43-.07.89.89,0,0,1-.51-.48.79.79,0,0,1-.07-.31h0a1.7,1.7,0,0,1-.94.31,1,1,0,0,1-.71-.35,1,1,0,0,1-.14-.22c-.21.12-.43.23-.65.34a1.32,1.32,0,0,1-1.1.08.72.72,0,0,1-.4-.51.76.76,0,0,1,0-.3l-.54.25a1.34,1.34,0,0,1-1,.1.72.72,0,0,1-.42-.4c-.09-.19-.2-.68.49-1.17a26.28,26.28,0,0,1,3.48-2.12,1.18,1.18,0,0,1-.87-.55.68.68,0,0,1,.06-.7.92.92,0,0,1,.41-.3,19.54,19.54,0,0,1,6.76-1.54,18.11,18.11,0,0,1,4.59.48l.63.11a30.58,30.58,0,0,0,6.76.33h0a.45.45,0,0,1,.45.43.46.46,0,0,1-.43.46,32.44,32.44,0,0,1-6.95-.34l-.64-.12a17.93,17.93,0,0,0-4.38-.47,19.13,19.13,0,0,0-6.13,1.34,8.37,8.37,0,0,0,2.48-.32.44.44,0,0,1,.28.84A25.57,25.57,0,0,0,305,84.06l3.67-1.68c.38-.19.76-.37,1.15-.52a.44.44,0,0,1,.35.81l-1.11.51a12.13,12.13,0,0,0-2.1,1.39A27.78,27.78,0,0,0,311.13,82a.44.44,0,0,1,.62.09.44.44,0,0,1-.08.62l-2.42,1.84.06,0,3.39-2a.45.45,0,0,1,.48.75l-2.12,1.48c-.34.24-.41.42-.4.44a1,1,0,0,0,.7-.12,26,26,0,0,1,5.53-1.7l.64-.17A4.78,4.78,0,0,1,319,83a10,10,0,0,1,2.25.44c.32.09.63.18.93.24l4.6,1.06a.44.44,0,0,1-.2.86c-1.53-.35-3.06-.71-4.6-1-.31-.07-.63-.16-1-.25a9.46,9.46,0,0,0-2-.41,3.84,3.84,0,0,0-1.22.22c-.23.06-.46.13-.7.17A25.44,25.44,0,0,0,311.72,86,2.43,2.43,0,0,1,310.79,86.18Z",
    fill: "#231f20"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M315.61,58.53c-.76.77-2.67,12.89-3.37,18.61",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M312.24,77.59h-.06a.44.44,0,0,1-.38-.49c.43-3.56,2.49-17.85,3.5-18.88a.45.45,0,0,1,.64.62c-.65.89-2.49,12.06-3.26,18.37A.45.45,0,0,1,312.24,77.59Z",
    fill: "#231f20"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "286.85 88.55 287.19 90.82 318.57 95.4 318.04 93.06 286.85 88.55",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57,95.89h-.07L287.12,91.3a.49.49,0,0,1-.41-.41l-.34-2.27a.47.47,0,0,1,.13-.42.53.53,0,0,1,.42-.14l31.19,4.52a.48.48,0,0,1,.4.37L319,95.3a.45.45,0,0,1-.11.43A.48.48,0,0,1,318.57,95.89Zm-31-5.5,30.33,4.43-.3-1.33-30.22-4.37Z",
    fill: "#231f20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M286.85,88.55s7.14-6.13,7.38-6.07,32.33,3.9,32.33,3.9L318,93.06Z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M318,93.55H318L286.78,89a.5.5,0,0,1-.4-.35.47.47,0,0,1,.15-.5c7.34-6.3,7.5-6.25,7.81-6.18.48.08,21.33,2.58,32.28,3.89a.49.49,0,0,1,.41.36.46.46,0,0,1-.17.51l-8.52,6.68A.48.48,0,0,1,318,93.55ZM288,88.22l29.92,4.33,7.44-5.83c-9.66-1.16-28.86-3.46-31-3.74C293.64,83.43,290.39,86.16,288,88.22Z",
    fill: "#231f20"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "318.57 95.4 326.76 88.55 326.56 86.38 318.04 93.06 318.57 95.4",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57,95.89a.4.4,0,0,1-.15,0,.46.46,0,0,1-.32-.35l-.53-2.34a.47.47,0,0,1,.17-.49L326.26,86a.49.49,0,0,1,.79.34l.19,2.17a.48.48,0,0,1-.17.42l-8.19,6.86A.51.51,0,0,1,318.57,95.89Zm0-2.64.29,1.27,7.38-6.18-.09-1Z",
    fill: "#231f20"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "286.85 88.55 280.82 68.34 313.9 73.98 318.04 93.06 286.85 88.55",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M318,93.55H318L286.78,89a.48.48,0,0,1-.4-.35l-6-20.2a.49.49,0,0,1,.55-.62L314,73.5a.48.48,0,0,1,.39.37L318.51,93a.46.46,0,0,1-.12.43A.48.48,0,0,1,318,93.55Zm-30.82-5.44,30.2,4.37L313.49,74.4l-32-5.45Z",
    fill: "#231f20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M333.38,88.08h-.08l-6.69-1.15a.5.5,0,0,1-.41-.47l-.21-8a.47.47,0,0,1,.44-.49l11.83-1.22L333,58.66a.49.49,0,0,1,.33-.6.49.49,0,0,1,.61.33L339.35,77a.47.47,0,0,1-.06.4.51.51,0,0,1-.35.22l-12,1.23.2,7.17,6.3,1.08a.49.49,0,0,1-.09,1Z",
    fill: "#231f20"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M289.49,119.66a21.64,21.64,0,0,0-1.73-1.44c-1.3-1-4.09-2.41-4.89-.11-.5,1.42.27,3.31.8,4.62a18.14,18.14,0,0,0,4.67,6.55c1.77,1.6,7.41,3.91,7-.55a6.57,6.57,0,0,0-.76-2.3A23.49,23.49,0,0,0,289.49,119.66Z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M293.26,131.77a9.18,9.18,0,0,1-5.21-2.16,18.61,18.61,0,0,1-4.79-6.71c-.54-1.34-1.36-3.35-.81-4.94a2.14,2.14,0,0,1,1.39-1.43c1.63-.49,3.78,1,4.19,1.34a22.33,22.33,0,0,1,1.76,1.46h0a23.85,23.85,0,0,1,5.2,6.9,7,7,0,0,1,.8,2.46c.16,1.74-.56,2.49-1.2,2.8A2.88,2.88,0,0,1,293.26,131.77Zm-8.72-14.45a1.51,1.51,0,0,0-.44.06,1.23,1.23,0,0,0-.81.88c-.44,1.26.3,3.09.79,4.3a17.7,17.7,0,0,0,4.56,6.39c1.26,1.15,4.22,2.42,5.56,1.75.57-.29.8-.92.71-1.93a6.3,6.3,0,0,0-.72-2.14,22.55,22.55,0,0,0-5-6.64c-.54-.5-1.11-1-1.69-1.41A5.72,5.72,0,0,0,284.54,117.32Z",
    fill: "#231f20"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M308.54,122.15a2.07,2.07,0,0,0-1.32-.37,1.67,1.67,0,0,0-.78.43,3.86,3.86,0,0,0-1.06,3.17,9.29,9.29,0,0,0,1.05,3.27c1.53,3.18,3.6,6.26,6.67,8a5.78,5.78,0,0,0,1.78.69c5.46,1,3.2-4.42,1.86-6.87A21.18,21.18,0,0,0,308.54,122.15Z",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M316.05,137.88a7.3,7.3,0,0,1-1.25-.12,6.16,6.16,0,0,1-1.91-.74c-2.7-1.52-4.94-4.19-6.86-8.17a10.14,10.14,0,0,1-1.1-3.43,4.26,4.26,0,0,1,1.21-3.53,2,2,0,0,1,1-.54,2.46,2.46,0,0,1,1.61.41h0a21.8,21.8,0,0,1,8.38,8.47c1,1.78,2.43,5,1.23,6.69A2.65,2.65,0,0,1,316.05,137.88Zm-8.64-15.67h-.12a1.18,1.18,0,0,0-.55.32,3.37,3.37,0,0,0-.92,2.8,8.82,8.82,0,0,0,1,3.12c1.83,3.82,4,6.36,6.48,7.78a5.14,5.14,0,0,0,1.64.64c1.37.25,2.27.08,2.67-.48.78-1.09-.15-3.68-1.28-5.74a20.83,20.83,0,0,0-8-8.12A2.06,2.06,0,0,0,307.41,122.21Z",
    fill: "#231f20"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M306.35,105a.48.48,0,0,1-.48-.44c0-.22-.55-5.59.37-8.65a.48.48,0,1,1,.93.27c-.86,2.88-.35,8.24-.34,8.29a.49.49,0,0,1-.44.53Z",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41.57,
    y: 67.31,
    width: 213.76,
    height: 151.41,
    rx: 7.55,
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M247.78,219.21H49.12a8.05,8.05,0,0,1-8-8V74.86a8,8,0,0,1,8-8H247.78a8,8,0,0,1,8,8V211.18A8,8,0,0,1,247.78,219.21ZM49.12,67.8a7.07,7.07,0,0,0-7.07,7.06V211.18a7.07,7.07,0,0,0,7.07,7.06H247.78a7.07,7.07,0,0,0,7.06-7.06V74.86a7.07,7.07,0,0,0-7.06-7.06Z",
    fill: "#231f20"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 49.47,
    y: 86.89,
    width: 197.95,
    height: 123.87,
    fill: "#231f20"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M247.42,211.26H49.47a.5.5,0,0,1-.5-.5V86.89a.5.5,0,0,1,.5-.5h198a.5.5,0,0,1,.5.5V210.76A.5.5,0,0,1,247.42,211.26ZM50,210.26h197V87.39H50Z",
    fill: "#231f20"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 49.47,
    y: 75.27,
    width: 197.95,
    height: 11.62,
    fill: "#9db0ef"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M247.42,87.39H49.47a.5.5,0,0,1-.5-.5V75.27a.5.5,0,0,1,.5-.5h198a.5.5,0,0,1,.5.5V86.89A.5.5,0,0,1,247.42,87.39ZM50,86.39h197V75.77H50Z",
    fill: "#9db0ef"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M89.16,99.22h-17a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49h17a.48.48,0,0,1,.48.49A.47.47,0,0,1,89.16,99.22Z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M127.51,99.22h-34a.47.47,0,0,1-.48-.48.48.48,0,0,1,.48-.49h34a.49.49,0,0,1,.49.49A.48.48,0,0,1,127.51,99.22Z",
    fill: "#9db0ef"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M139.26,106.34h-34a.49.49,0,1,1,0-1h34a.49.49,0,0,1,0,1Z",
    fill: "#9db0ef"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M93.15,106.34h-17a.49.49,0,0,1,0-1h17a.49.49,0,0,1,0,1Z",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M97.15,113.45h-17a.49.49,0,0,1-.49-.49.48.48,0,0,1,.49-.48h17a.47.47,0,0,1,.48.48A.48.48,0,0,1,97.15,113.45Z",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M145.33,113.45H102.82a.48.48,0,0,1-.48-.49.47.47,0,0,1,.48-.48h42.51a.48.48,0,0,1,.49.48A.49.49,0,0,1,145.33,113.45Z",
    fill: "#9db0ef"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M101.14,120.56h-17a.49.49,0,0,1-.48-.49.48.48,0,0,1,.48-.48h17a.48.48,0,0,1,.49.48A.49.49,0,0,1,101.14,120.56Z",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M154.12,120.56H103.58a.49.49,0,0,1-.49-.49.48.48,0,0,1,.49-.48h50.54a.48.48,0,0,1,.49.48A.49.49,0,0,1,154.12,120.56Z",
    fill: "#9db0ef"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M96.63,127.67h-17a.49.49,0,1,1,0-1h17a.49.49,0,0,1,0,1Z",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M127.51,127.67H100.1a.49.49,0,0,1,0-1h27.41a.49.49,0,1,1,0,1Z",
    fill: "#9db0ef"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M165.39,127.67H138a.49.49,0,1,1,0-1h27.41a.49.49,0,0,1,0,1Z",
    fill: "#9db0ef"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M96.63,134.78h-17a.49.49,0,1,1,0-1h17a.49.49,0,0,1,0,1Z",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M127.51,134.78H103.58a.49.49,0,1,1,0-1h23.93a.49.49,0,1,1,0,1Z",
    fill: "#9db0ef"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M141.33,134.78h-9.78a.49.49,0,1,1,0-1h9.78a.49.49,0,1,1,0,1Z",
    fill: "#9db0ef"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M96.63,141.89h-17a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49h17a.48.48,0,0,1,.48.49A.47.47,0,0,1,96.63,141.89Z",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M136.1,141.89h-35a.48.48,0,0,1-.48-.48.49.49,0,0,1,.48-.49h35a.49.49,0,0,1,.49.49A.48.48,0,0,1,136.1,141.89Z",
    fill: "#9db0ef"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M157.24,141.89h-17a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49h17a.49.49,0,0,1,.48.49A.48.48,0,0,1,157.24,141.89Z",
    fill: "#9db0ef"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M84.64,149h-9a.49.49,0,0,1,0-1h9a.49.49,0,0,1,0,1Z",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M131.55,149H92.11a.49.49,0,0,1,0-1h39.44a.49.49,0,0,1,0,1Z",
    fill: "#9db0ef"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M92.63,156.12h-17a.49.49,0,0,1,0-1h17a.49.49,0,0,1,0,1Z",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M112.09,163.23h-34a.48.48,0,0,1-.48-.49.47.47,0,0,1,.48-.48h34a.48.48,0,0,1,.49.48A.49.49,0,0,1,112.09,163.23Z",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M141.33,163.23H117.72a.48.48,0,0,1-.48-.49.47.47,0,0,1,.48-.48h23.61a.48.48,0,0,1,.49.48A.49.49,0,0,1,141.33,163.23Z",
    fill: "#9db0ef"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M173.94,163.23H144.71a.48.48,0,0,1-.48-.49.47.47,0,0,1,.48-.48h29.23a.48.48,0,0,1,.48.48A.49.49,0,0,1,173.94,163.23Z",
    fill: "#9db0ef"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M129.11,170.34H79.61a.49.49,0,0,1-.49-.49.48.48,0,0,1,.49-.48h49.5a.48.48,0,0,1,.49.48A.49.49,0,0,1,129.11,170.34Z",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M154.76,170.34H132.49a.49.49,0,0,1-.49-.49.48.48,0,0,1,.49-.48h22.27a.47.47,0,0,1,.48.48A.48.48,0,0,1,154.76,170.34Z",
    fill: "#9db0ef"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M224.75,170.34H158.53a.49.49,0,0,1-.48-.49.48.48,0,0,1,.48-.48h66.22a.48.48,0,0,1,.49.48A.49.49,0,0,1,224.75,170.34Z",
    fill: "#9db0ef"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M102.82,177.45H79.41a.49.49,0,1,1,0-1h23.41a.49.49,0,1,1,0,1Z",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M124.72,177.45H107.48a.49.49,0,1,1,0-1h17.24a.49.49,0,0,1,0,1Z",
    fill: "#9db0ef"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,177.45H129.36a.49.49,0,1,1,0-1H146.6a.49.49,0,0,1,0,1Z",
    fill: "#9db0ef"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M120.8,184.56H79.41a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49H120.8a.49.49,0,0,1,.49.49A.48.48,0,0,1,120.8,184.56Z",
    fill: "#fff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,184.56H125.9a.47.47,0,0,1-.48-.48.48.48,0,0,1,.48-.49h20.7a.48.48,0,0,1,.48.49A.47.47,0,0,1,146.6,184.56Z",
    fill: "#9db0ef"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M183.2,184.56H151.68a.47.47,0,0,1-.48-.48.48.48,0,0,1,.48-.49H183.2a.49.49,0,0,1,.49.49A.48.48,0,0,1,183.2,184.56Z",
    fill: "#9db0ef"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M218,184.56H186.52a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49H218a.49.49,0,0,1,.49.49A.48.48,0,0,1,218,184.56Z",
    fill: "#9db0ef"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M114.57,191.67H89.88a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49h24.69a.48.48,0,0,1,.48.49A.47.47,0,0,1,114.57,191.67Z",
    fill: "#fff"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M143.89,191.67H119.2a.47.47,0,0,1-.48-.48.48.48,0,0,1,.48-.49h24.69a.49.49,0,0,1,.49.49A.48.48,0,0,1,143.89,191.67Z",
    fill: "#9db0ef"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M173.42,191.67H148.73a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49h24.69a.48.48,0,0,1,.48.49A.47.47,0,0,1,173.42,191.67Z",
    fill: "#9db0ef"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M204,192.47H179.3a.49.49,0,1,1,0-1H204a.49.49,0,1,1,0,1Z",
    fill: "#9db0ef"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M110.57,198.78h-17a.47.47,0,0,1-.48-.48.48.48,0,0,1,.48-.49h17a.49.49,0,0,1,.49.49A.48.48,0,0,1,110.57,198.78Z",
    fill: "#fff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M131.59,198.78h-17a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49h17a.48.48,0,0,1,.48.49A.47.47,0,0,1,131.59,198.78Z",
    fill: "#9db0ef"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M170.89,199.5h0l-35.14-.72a.48.48,0,0,1-.48-.49.47.47,0,0,1,.5-.48l35.14.72a.49.49,0,1,1,0,1Z",
    fill: "#9db0ef"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M184,120.56H161a.48.48,0,0,1-.48-.49.47.47,0,0,1,.48-.48h23a.48.48,0,0,1,.49.48A.49.49,0,0,1,184,120.56Z",
    fill: "#9db0ef"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M201,120.63c-4.5,0-7.84,0-8-.1a.48.48,0,0,1,.26-.93c.88.11,16.06.05,26.1,0h0a.48.48,0,0,1,.49.48.49.49,0,0,1-.49.49C214,120.59,206.6,120.63,201,120.63Z",
    fill: "#9db0ef"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M180.33,106.34h-33.4a.49.49,0,0,1,0-1h33.4a.49.49,0,0,1,0,1Z",
    fill: "#9db0ef"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M220.28,106.34H187a.49.49,0,1,1,0-1h33.24a.49.49,0,0,1,0,1Z",
    fill: "#9db0ef"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M149,99.26c-6.17,0-10.87,0-11.06,0a.49.49,0,0,1-.4-.56.48.48,0,0,1,.54-.4c.85.06,25.51,0,38.45,0h0a.49.49,0,0,1,.49.49.48.48,0,0,1-.49.48C171.1,99.24,158.34,99.26,149,99.26Z",
    fill: "#9db0ef"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M185.54,99.25a.47.47,0,0,1-.42-.28.53.53,0,0,1,.26-.67c.39-.19,8.16-.21,23.08,0a.5.5,0,0,1,.48.49.48.48,0,0,1-.49.48h0c-8.69-.09-21.9-.17-22.72,0A.34.34,0,0,1,185.54,99.25Z",
    fill: "#fff"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M153.32,149H136.1a.49.49,0,0,1,0-1h17.22a.49.49,0,1,1,0,1Z",
    fill: "#9db0ef"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M113.81,156.12H101.14a.49.49,0,0,1,0-1h12.67a.49.49,0,0,1,0,1Z",
    fill: "#9db0ef"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M148.73,156.12H118.62a.49.49,0,0,1,0-1h30.11a.49.49,0,0,1,0,1Z",
    fill: "#fff"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M213.09,156.12H154.76a.49.49,0,1,1,0-1h58.33a.49.49,0,0,1,0,1Z",
    fill: "#9db0ef"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 81.08,
    r: 1.7,
    fill: "#231f20"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.96,
    cy: 81.08,
    r: 1.7,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.92,
    cy: 81.08,
    r: 1.7,
    fill: "#fff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "180.25 240.64 116.64 240.64 123.83 218.72 173.06 218.72 180.25 240.64",
    fill: "#fff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M180.25,241.14H116.64a.49.49,0,0,1-.48-.65l7.19-21.92a.5.5,0,0,1,.48-.35h49.23a.5.5,0,0,1,.48.35l7.19,21.92a.49.49,0,0,1-.48.65Zm-62.92-1h62.23l-6.86-20.92H124.19Z",
    fill: "#231f20"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 108.3,
    y: 240.64,
    width: 80.29,
    height: 6.17,
    rx: 3.09,
    fill: "#fff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M185.51,247.32H111.39a3.59,3.59,0,0,1,0-7.18h74.12a3.59,3.59,0,0,1,0,7.18Zm-74.12-6.18a2.59,2.59,0,0,0,0,5.18h74.12a2.59,2.59,0,0,0,0-5.18Z",
    fill: "#231f20"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M118.55,234.83c1-.54,56.1-10.6,56.1-10.6l-1.81-5.51H123.61Z",
    fill: "#231f20"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M118.54,235.33a.47.47,0,0,1-.31-.12.48.48,0,0,1-.14-.52l5.06-16.11a.47.47,0,0,1,.46-.34h49.23a.47.47,0,0,1,.46.33l1.81,5.5a.5.5,0,0,1-.38.63c-15.1,2.76-54.61,10.05-56,10.58A.54.54,0,0,1,118.54,235.33ZM124,219.21l-4.7,14.95c6.62-1.5,45.18-8.56,54.74-10.31l-1.52-4.64Z",
    fill: "#231f20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDev);
export default __webpack_public_path__ + "static/media/app_dev.c858047bad08c695fc569f1a0e730d23.svg";
export { ForwardRef as ReactComponent };